import apiRequest from './client';

// Nombre de boules par fiche (menu Securite). Portée company / group / bank ;
// au plus une règle par cible côté backend (MaxBoulesRule). Quand aucune règle
// n'existe, le plafond historique de 20 boules par fiche s'applique ; une règle
// activée le remplace par `max_count`, une règle désactivée lève le plafond.

export const listMaxBoulesRules = ({ group, bank } = {}) => {
  const params = new URLSearchParams();
  if (group) params.set('group', group);
  else if (bank) params.set('bank', bank);
  const qs = params.toString();
  return apiRequest(`/max-boules-rules/${qs ? `?${qs}` : ''}`);
};

export const createMaxBoulesRule = (data) =>
  apiRequest('/max-boules-rules/', { method: 'POST', body: data });

export const updateMaxBoulesRule = (id, data) =>
  apiRequest(`/max-boules-rules/${id}/`, { method: 'PATCH', body: data });

export const deleteMaxBoulesRule = (id) =>
  apiRequest(`/max-boules-rules/${id}/`, { method: 'DELETE' });
